/* Sticky buy bar for the standard product page (all screen sizes).
 * Shown once the Add to bag button has scrolled up out of view, hidden again when the product lists
 * (Pair it with / Similar products / reviews) are reached. Its button clicks the real Add to bag button, so the variant, the cart
 * drawer and errors work exactly as in the page itself. Title, chosen options, price and picture follow the
 * selection. */
(() => {
  if (customElements.get('sf-mobile-buy')) return;
  customElements.define(
    'sf-mobile-buy',
    class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        this.root = document.getElementById('MainProduct-' + this.dataset.sectionId);
        if (!this.root) return;
        this.section = this.root.closest('.shopify-section') || this.root;
        const opts = { signal: this.abort.signal };
        this.addEventListener(
          'click',
          (event) => {
            if (event.target.closest('[data-mobile-buy-action]')) this.button()?.click();
          },
          opts,
        );
        let queued = false;
        const schedule = () => {
          if (queued) return;
          queued = true;
          requestAnimationFrame(() => {
            queued = false;
            this.update();
          });
        };
        window.addEventListener('scroll', schedule, { ...opts, passive: true });
        window.addEventListener('resize', schedule, opts);
        this.root.addEventListener('change', () => setTimeout(schedule, 60), opts);
        this.mutations = new MutationObserver(schedule);
        this.mutations.observe(this.root, {
          childList: true,
          subtree: true,
          characterData: true,
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled', 'src', 'srcset'],
        });
        this.update();
      }
      button() {
        return this.root.querySelector('.product-form__submit');
      }
      selection() {
        const picker = this.root.querySelector('variant-selects');
        if (!picker) return '';
        const values = [];
        picker.querySelectorAll('fieldset, .product-form__input--dropdown').forEach((group) => {
          const checked = group.querySelector('input:checked');
          const select = group.querySelector('select');
          if (checked) values.push(checked.value);
          else if (select) values.push(select.value);
        });
        return values.join(' · ');
      }
      update() {
        const button = this.button();
        const headerBottom = document.querySelector('.sf-header')?.getBoundingClientRect().bottom || 0;
        const passed = button ? button.getBoundingClientRect().bottom < headerBottom : false;
        // Stays while the visitor reads about this product (details, highlights); hides when the product lists
        // (Pair it with / Similar products / reviews) or the footer come into view.
        let stop = this.section.nextElementSibling;
        while (stop && !stop.matches('.shopify-section:has(.sf-pair-with, .live-recommendations, .sf-customer-reviews, [class*="review"]), .shopify-section-group-footer-group'))
          stop = stop.nextElementSibling;
        stop = stop || document.querySelector('footer');
        const inSection = !stop || stop.getBoundingClientRect().top > window.innerHeight - 40;
        const show = Boolean(button) && passed && inSection;
        if (this.hidden === show) this.hidden = !show;
        document.documentElement.classList.toggle('sf-sticky-buy-open', show);
        if (!show || !button) return;
        const action = this.querySelector('[data-mobile-buy-action]');
        action.disabled = button.disabled || button.getAttribute('aria-disabled') === 'true';
        action.querySelector('span').textContent = button.querySelector('span')?.textContent?.trim() || '';
        const price =
          this.root.querySelector('[id^="price-"] .price--on-sale .price-item--sale') ||
          this.root.querySelector('[id^="price-"] .price-item--regular');
        this.querySelector('[data-mobile-buy-price]').textContent = price?.textContent?.trim() || '';
        const chosen = this.selection();
        const sel = this.querySelector('[data-sticky-buy-selection]');
        if (sel && chosen) sel.textContent = chosen;
        const img = this.querySelector('.sf-sticky-buy-thumb img');
        const active = this.root.querySelector('.product__media-item.is-active img, .product__media-item img');
        if (img && active?.currentSrc && img.dataset.src !== active.currentSrc) {
          img.dataset.src = active.currentSrc;
          img.removeAttribute('srcset');
          img.src = active.currentSrc;
        }
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.mutations?.disconnect();
        document.documentElement.classList.remove('sf-sticky-buy-open');
      }
    },
  );
})();
